<template>
    <nav v-if="shouldShowPagination" class="my-pagination">
        <p class="descleft">{{von}} bis {{bis}} von {{pagination.totalItems}} Einträge</p>
        <p class="desc">Seite {{pagination.currentPage}} von {{pagination.totalPages}}</p>
        <ul class="pagination justify-content-left">
            <li :class="{ disabled: pagination.currentPage === 1 }">
                <a class="page-link" :class="{ disabled: pagination.currentPage === 1 }"
                   @click="pageClicked( pagination.currentPage - 1 )" @mousedown="pageMouseDown( '-' )" @mouseup="pageMouseUp()">
                   <!-- <img src="../../../../static/svg/back.svg" height="10" style="margin: 0 4px 2px 0"/> -->
                   <font-icon icon="angle-left" size="lg" style="margin: 0 6px 0 0"/> ZURÜCK
                </a>
            </li>
            <li v-if="hasFirst" class="page-item" :class="{ active: isActive(1) }">
                <a class="page-link" @click="pageClicked(1)">1</a>
            </li>
            <li v-if="hasFirstEllipsis"><span class="pagination-ellipsis">&hellip;</span></li>
            <li class="page-item" :class="{ active: isActive(page), disabled: page === '...' }" v-for="page in pages" :key="page">
                <a class="page-link" @click="pageClicked(page)">{{ page }}</a>
            </li>
            <li v-if="hasLastEllipsis"><span class="pagination-ellipsis">&hellip;</span></li>
            <li v-if="hasLast" class="page-item"
                :class="{ active: isActive(this.pagination.totalPages) }">
                <a class="page-link" @click="pageClicked(pagination.totalPages)">{{pagination.totalPages}}</a>
            </li>
            <li>
                <a class="page-link" :class="{ disabled: pagination.currentPage === pagination.totalPages }"
                   @click="pageClicked( pagination.currentPage + 1 )" @mousedown="pageMouseDown( '+' )" @mouseup="pageMouseUp()">VOR <font-icon icon="angle-right" size="lg" style="margin: 0 0 0 6px"/>                        
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>

    export default {
        props: {
            pagination: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                timer : {},
                plusMinus : ''
            };
        },
        mounted() {
            //console.log(this.pagination);
        },
        computed: {
            pages() {
                return this.pagination.totalPages === undefined
                    ? []
                    : this.pageLinks();
            },
            von(){
                return this.pagination.rowMax * (this.pagination.currentPage-1) + 1;
            },
            bis(){
                return ( (this.pagination.currentPage * this.pagination.rowMax) > this.pagination.totalItems ) ? this.pagination.totalItems : (this.pagination.currentPage * this.pagination.rowMax)
            },
            hasFirst() {
                return this.pagination.currentPage >= 4 || this.pagination.totalPages < 7
            },

            hasLast() {
                return this.pagination.currentPage <= this.pagination.totalPages - 3 || this.pagination.totalPages < 7
            },

            hasFirstEllipsis() {
                return this.pagination.currentPage >= 4 && this.pagination.totalPages >= 7
            },

            hasLastEllipsis() {
                return this.pagination.currentPage <= this.pagination.totalPages - 3 && this.pagination.totalPages >= 7
            },

            shouldShowPagination() {
                if (this.pagination.totalPages === undefined) {
                    return false;
                }

                if (this.pagination.count === 0) {
                    return false;
                }

                return this.pagination.totalPages > 1;
            },

        },

        methods: {
            isActive(page) {
                const currentPage = this.pagination.currentPage || 1;

                return currentPage === page;
            },

            pageClicked(page) {
                if (page === '...' ||
                    page === this.pagination.currentPage ||
                    page > this.pagination.totalPages ||
                    page < 1) {
                    return;
                }

                this.$emit('pageChange', page);
            },

            pageLinks() {
                const pages = [];

                let left = 2;
                let right = this.pagination.totalPages - 1;

                if (this.pagination.totalPages >= 7) {
                    left = Math.max(1, this.pagination.currentPage - 2);
                    right = Math.min(this.pagination.currentPage + 2, this.pagination.totalPages);
                }

                for (let i = left; i <= right; i++) {
                    pages.push(i);
                }

                return pages;
            },
            pageMouseDown(plusMinus){
                this.plusMinus = plusMinus;
                this.timer = setInterval( this.nextStep, 100 );
            },
            pageMouseUp(){
                clearInterval(this.timer);
            },
            nextStep: function(){
                if( this.plusMinus === '-' ){
                    if( this.pagination.currentPage > 1 ){
                       this.pagination.currentPage--; 
                       this.$emit('pageChange', this.pagination.currentPage);
                    }
                    else{
                        clearInterval(this.timer);
                    }
                }
                else if(this.plusMinus === '+'){
                    if( this.pagination.currentPage < this.pagination.totalPages ){
                       this.pagination.currentPage++; 
                       this.$emit('pageChange', this.pagination.currentPage);
                    }
                    else{
                        clearInterval(this.timer);
                    }
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.timer)
        }
    };
</script>

<style scoped>
.pagination-ellipsis{
    display: inline-block;
    padding: 7px 6px 0; 
}
.my-pagination{
    display: flex;
    flex-flow: row wrap;
    font-size: 0.9rem;
    margin-top: 9px;
    /* background-color: #e8ecf0;
    border-bottom: 1px solid #d9dce0; */
    -ms-user-select: none; 
    -moz-user-select: none; 
    -webkit-user-select: none; 
    line-height: 1.5;
    flex: 2 0px;
}
.my-pagination p.desc{
    margin: 0.8rem 0.9rem 0 0;
    font-style: italic;
    color: #636566;
    text-align: right;
}
.my-pagination p.descleft{
    margin: 0.8rem 0.9rem 0 0;
    font-style: italic;
    color: #636566;
    flex: 1 0px;
}


.my-pagination ul {
    margin: 0;
}
.page-link {
    padding: 0.55rem 0.80rem;
    border: 1px solid #dee2e6; 
    border-top: none;
    border-bottom: none;
    position: relative;
    display: block;
    padding: 0.6rem 0.85rem;
    margin-left: -1px;
    line-height: 1.5;
    color: #333;
    background-color: #fff;
    cursor: pointer;   
    white-space: nowrap;
}
li.active a{
    background-color: #1F8CC4;   
    color: white;
    cursor: default;
}

li.disabled a {
    color: #a7a7a7;
    cursor: default;
}
.page-item{
    display: flex;
}

li:not(.disabled):not(.active) .page-link:hover{
    background-color: #eff3f7;
}
.pagination {
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-bottom: 1px solid #d9dce0;
    border-top: 1px solid #d9dce0;
}
ul li{
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/table/_BaseTablePagination.vue